// https://leafty.medium.com/getting-started-with-logging-in-react-e8d493458689

/** Signature of a logging function */
export interface LogFn {
  (message?: any, ...optionalParams: any[]): void;
}



/** Basic logger interface */
export interface Logger {
  log: LogFn;
  warn: LogFn;
  error: LogFn;
}

/** Log levels */
export type LogLevel = 'log' | 'warn' | 'error' | 'none';

const NO_OP: LogFn = (message?: any, ...optionalParams: any[]) => {};

/** Logger which outputs to the browser console
 * levels:
 *    'log' -> logs all levels
 *    'warn' -> logs error and warn
 *    'error' -> logs error
 *    'none' -> no logs
 *
 * */
class ConsoleLogger implements Logger {
  readonly log: LogFn;
  readonly warn: LogFn;
  readonly error: LogFn;

  constructor(options?: { level? : LogLevel }) {
    const { level } = options || {};

    if(level === 'none'){
      this.error = NO_OP
      this.warn = NO_OP
      this.log = NO_OP

      return
    }

    this.error = console.error.bind(console);

    if (level === 'error') {
      this.warn = NO_OP
      this.log = NO_OP

      return
    }

    this.warn = console.warn.bind(console);

    if (level === 'warn') {
      this.log = NO_OP

      return
    }

    this.log = console.log.bind(console)
  }
}

const logger = new ConsoleLogger({level: 'none'})

export default logger;